export class Constants {
    public static URNMAIL: string = "urn:mail:"

    public static EMPTY_STRING: string = "";

    public static YES: string = "EVET";

    public static NO: string = "HAYIR";

    public static TURKEY: string = "TR|TÜRKİYE";
    public static PORTAL: string = "Portal";
    public static DEFAULTGB: string = "defaultgb";
    public static DEFAULTPK: string = "defaultpk";

    public static IRSALIYEGB: string = "irsaliyegb";
    public static IRSALIYEPK: string = "irsaliyepk";

    public static DEFAULT_BRANCH: string = "default";


    // public static DEFAULT_PREFIX: string = "FA";

    public static SOVOSCOM:string = "www.sovos.com";

    public static WWW:string = "www.";

    public static LOGO:string = "logo";

    public static SIGNATURE:string = "signature";

    public static MAX_LOGO_SIGNATURE_FILE_SIZE_IN_KB:number = 100;

    public static DOMAIN_NAME_SOVOSCOM:string = "sovos.com"

}